import { render } from "./TestWebhookDeliveryView.vue?vue&type=template&id=845db952&scoped=true"
import script from "./TestWebhookDeliveryView.vue?vue&type=script&lang=js"
export * from "./TestWebhookDeliveryView.vue?vue&type=script&lang=js"

import "./TestWebhookDeliveryView.vue?vue&type=style&index=0&id=845db952&scoped=true&lang=scss"

import exportComponent from "/root/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-845db952"]])

export default __exports__